/**
 * Returns the app name.
 */
export const useAppName = (): boolean => {
  const appName = import.meta.env.VITE_APP_NAME || 'HeartMap';
  return appName;
};
